export default {
  properties: (state) => {
    return state.properties;
  },

  property: (state) => {
    return state.current_property;
  },

  amenities: (state) => {
    return state.amenities;
  },

  query: (state) => {
    return state.query;
  },

  searchResults: (state) => {
    return state.searchResults;
  },

  searchResultsCurrentPage: (state) => {
    return state.searchResultsCurrentPage;
  },

  searchResultsTotal: (state) => {
    return state.searchResultsTotal;
  },

  loading: (state) => {
    return state.loading;
  },
};
